import { z } from 'zod';
import { ShopifyOrdersDataResponseSchema } from '~/types/ShopifyOrdersData';
import { B2CApiResponseSchema } from './B2COrdersData';

type TableOrder = 'asc' | 'desc';

const OrdersResponseDataSchema = z.union([ShopifyOrdersDataResponseSchema, B2CApiResponseSchema]);
type OrdersResponseDataType = z.infer<typeof OrdersResponseDataSchema>;

const OrdersTableStatusSchema = z.enum(['all', 'awaitingApproval', 'approved', 'rejected']);
type OrdersTableStatusType = z.infer<typeof OrdersTableStatusSchema>;

const OrdersTableRowSchema = z.object({
  id: z.string(),
  product: z.string(),
  sku: z.string(),
  quantity: z.number(),
  orderDate: z.string(),
  pharmacy: z.string(),
  address: z.string().optional(),
  contact: z.string().optional(),
  approval: z.object({
    id: z.string(),
    documentPath: z.string().optional()
  }),
  doctor: z.string().optional(),
  status: z.string(),
  dispatch: z.string().nullable()
});
type OrdersTableRowType = z.infer<typeof OrdersTableRowSchema>;

const OrdersRowKeysSchema = z.custom<keyof OrdersTableRowType>((value) => {
  return Object.keys(OrdersTableRowSchema.shape).includes(value);
});
type OrdersRowKeysType = z.infer<typeof OrdersRowKeysSchema>;

const OrdersTableHeadCellSchema = z.object({
  id: OrdersRowKeysSchema,
  label: z.string(),
  visible: z.boolean().optional()
});
type OrdersTableHeadCellType = z.infer<typeof OrdersTableHeadCellSchema>;

const OrdersTableDataSchema = z.object({
  type: z.enum(['b2b', 'b2c']),
  rows: z.array(OrdersTableRowSchema)
});
type OrdersTableDataType = z.infer<typeof OrdersTableDataSchema>;

export {
  OrdersResponseDataSchema,
  OrdersRowKeysSchema,
  OrdersTableDataSchema,
  OrdersTableHeadCellSchema,
  OrdersTableRowSchema,
  OrdersTableStatusSchema
};

export type {
  OrdersResponseDataType,
  OrdersRowKeysType,
  OrdersTableDataType,
  OrdersTableHeadCellType,
  OrdersTableRowType,
  OrdersTableStatusType,
  TableOrder
};
